import { Switch, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

type MenuStatus = "not_live" | "live" | "paused";

export interface MenuSource {
  id: string;
  designId: string;
  name: string;
  thumbUrl?: string;
  publishedAt?: string;
  status: MenuStatus;
}

interface Props {
  menu: MenuSource;
  publishing?: boolean;
  // Opens the design in the mkdesigner editor (clicking the thumbnail).
  onOpenDesign: () => void;
  onEdit: () => void;
  onDelete: () => void;
  // Flipping the toggle connects (publishes) the menu when on, or pauses syncing when off.
  onToggleConnect: (connected: boolean) => void;
}

export function MenuSourceTile({ menu, publishing, onOpenDesign, onEdit, onDelete, onToggleConnect }: Props) {
  const connected = menu.status === "live";

  return (
    <div className="menu-row">
      <div className="menu-row-media">
        <button
          type="button"
          className="menu-row-thumb-btn"
          onClick={onOpenDesign}
          aria-label={`Open ${menu.name} in the editor`}
          title="Open in editor"
        >
          {menu.thumbUrl ? (
            <img src={menu.thumbUrl} alt={menu.name} />
          ) : (
            <div className="menu-row-thumb-placeholder" />
          )}
        </button>

        <div className="menu-row-actions">
          <Tooltip title="Edit">
            <button type="button" className="menu-row-action" aria-label="Edit" onClick={onEdit}>
              <EditOutlined />
            </button>
          </Tooltip>
          <Tooltip title="Delete">
            <button type="button" className="menu-row-action" aria-label="Delete" onClick={onDelete}>
              <DeleteOutlined />
            </button>
          </Tooltip>
        </div>
      </div>

      <div className="menu-row-info">
        <span className={`menu-conn-badge${connected ? " connected" : ""}`}>
          <span className="menu-conn-dot" />
          {connected ? "CONNECTED" : "NOT CONNECTED"}
        </span>
        <div className="menu-row-title">{menu.name}</div>
        {menu.publishedAt && <div className="menu-row-date">Published {menu.publishedAt}</div>}
      </div>

      <div className="menu-row-toggle">
        {connected ? (
          <span className="menu-row-syncing">
            <span className="menu-conn-dot" />
            Syncing
          </span>
        ) : (
          <span className="menu-row-connect-label">Connect</span>
        )}
        <Switch checked={connected} loading={publishing} onChange={onToggleConnect} />
      </div>
    </div>
  );
}
